var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVignetteEffect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 770,
    viewBox: "0 0 1920 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 770,
    fill: "url(#paint0_linear_26_10)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 770,
    fill: "url(#paint1_linear_26_10)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 770,
    fill: "url(#paint2_linear_26_10)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 770,
    fill: "url(#paint3_linear_26_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_10",
    x1: 980.5,
    y1: 462.5,
    x2: 960,
    y2: 770,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136433,
    stopOpacity: 0.106473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301585,
    stopOpacity: 0.235359
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569957,
    stopOpacity: 0.492821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796055,
    stopOpacity: 0.740286
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_10",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 186.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19231,
    stopOpacity: 0.689555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385665,
    stopOpacity: 0.439033
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626007,
    stopOpacity: 0.20628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_10",
    x1: 254.5,
    y1: 319.5,
    x2: 511.5,
    y2: 319.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098808,
    stopOpacity: 0.984059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163071,
    stopOpacity: 0.967732
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227797,
    stopOpacity: 0.865569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71833,
    stopOpacity: 0.230315
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_10",
    x1: 1649,
    y1: 385,
    x2: 1427,
    y2: 385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0835706,
    stopOpacity: 0.873268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207018,
    stopOpacity: 0.720529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507774,
    stopOpacity: 0.294577
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671586,
    stopOpacity: 0.159921
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVignetteEffect);
export default __webpack_public_path__ + "static/media/VignetteEffect.52d62eda9722d8b176c34688a63fe166.svg";
export { ForwardRef as ReactComponent };